<template>
  <div>
    <div class="y-form-group">
      <el-row class="y-form-group-header">
        <el-col class="y-form-group-header__icon icon-setup-login" :span="4">&nbsp;</el-col>
        <el-col class="y-form-group-header__text" :span="20">{{ $lang.messages.setup_header_login }}</el-col>
      </el-row>
      <div class="y-form-item-group">
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <div class="y-form-row y-form-row__fullwidth">
              <label
                class="y-form-label y-form-label__heavy is-required"
              >{{ $lang.messages.form_label_login_mechanism }}</label>
              <el-radio-group
                class="y-radio-group y-radio-group__vertical"
                v-model="authConfig.loginMechanism"
              >
                <el-radio label="jwt">JWT</el-radio>
                <el-radio label="saml">SAML</el-radio>
              </el-radio-group>
            </div>
            <div class="ref-flow-jwt clearfix" v-show="authConfig.loginMechanism == 'jwt'">
              <div class="y-form-row y-form-row__static-text">
                <label
                  class="y-form-label y-form-label__heavy"
                >{{ $lang.messages.form_label_algorithm }}:</label>
                <span class="y-form-inline-data">{{jwtCommonData.algorithm}}</span>
              </div>
              <div class="y-form-row y-form-row__fullwidth">
                <label
                  class="y-form-label y-form-label__heavy is-required"
                >{{ $lang.messages.form_label_session_timeout }}</label>
                <div class="y-form-pre-post-ctr">
                  <el-input
                    v-model="jwtCommonData.expTime"
                    placeholder="#"
                    class="y-form-input y-form-input__small"
                    :class="errors.first('expTime') ? 'y-form-input-error':''"
                    style="width:75px"
                    data-vv-validate-on="change"
                    name="expTime"
                    v-validate="{ required:true, numeric: true, max_value: 1800 }"
                  ></el-input>
                  <span class="y-form-post-text">seconds</span>
                </div>
                <span class="y-form-error errorField" v-show="errors.first('expTime')">
                  <i class="el-icon-warning"></i>
                  {{ errors.first('expTime')}}
                </span>
              </div>
            </div>
            <div class="ref-flow-saml clearfix" v-show="authConfig.loginMechanism == 'saml'">
              <div class="y-form-row y-form-row__fullwidth">
                <span class="y-form-hint-text">{{ $lang.messages.form_hint_saml_flow }}</span>
              </div>
            </div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <div class="y-form-sub-header">
              <div class="y-form-row y-form-row__fullwidth">
                <span
                  class="y-form-sub-head__text y-form-sub-head__icon y-form-sub-head__icon-private"
                >{{ $lang.messages.form_sub_head_private }}</span>
              </div>
            </div>
            <setup-login-form :loginFormProps="devAuthConfig" envProp="DEVELOPMENT" />
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <div class="y-form-sub-header">
              <div class="y-form-row y-form-row__fullwidth">
                <span
                  class="y-form-sub-head__text y-form-sub-head__icon y-form-sub-head__icon-public"
                >{{ $lang.messages.form_sub_head_public }}</span>
              </div>
            </div>
            <setup-login-form :loginFormProps="prodAuthConfig" envProp="PRODUCTION" />
          </el-col>
        </el-row>
      </div>
    </div>
    <el-button class="y-button" @click="saveLogin">Save</el-button>
  </div>
</template>

<script>
import serviceRegistery from '../../mixins/serviceRegistery'
import setupLoginForm from './setup_login_form'
import Vue from 'vue'
import Vuex from 'vuex'
import { mapActions } from 'vuex'
Vue.use(Vuex)
export default {
  name: 'SetupLogin',
  inject: ['$validator'],
  components: {
    'setup-login-form': setupLoginForm
  },
  data() {
    return {}
  },
  created() {},
  computed: {
    setupTemplateData() {
      return this.$store.state.createSubbrandStore.setupTemplateData
    },
    authConfig() {
      let authConfig = this.setupTemplateData.config.authConfig
      return authConfig
    },
    devAuthConfig() {
      let devAuthConfig = this.authConfig.development.auths
      return devAuthConfig
    },
    prodAuthConfig() {
      let prodAuthConfig = this.authConfig.production.auths
      return prodAuthConfig
    },
    jwtCommonData() {
      let jwtCommonData = {}
      if (this.devAuthConfig && this.devAuthConfig.jwt) {
        jwtCommonData = this.devAuthConfig.jwt[0]
      }
      return jwtCommonData
    }
  },
  methods: {
    ...mapActions([]),
    saveLogin() {
      console.log('Save Login Details')
      this.$validator.validateAll().then(result => {
        if (result) {
          console.log('All Valid')
        }
      })
      var subbrandDataObj = {
        config: {
          authConfig: this.$store.state.createSubbrandStore.setupTemplateData
            .config.authConfig
        }
      }
      let _id = this.$store.state.appStore.selectedSubbrandInfo._id
      let reqObj = {
        id: _id,
        jsonData: JSON.stringify(subbrandDataObj)
      }

      console.log('Update Request Obj------>', subbrandDataObj)
      if (_id) {
        serviceRegistery
          .makeCall({
            url: this.$hostname + 'services/subbrand/update',
            method: 'POST',
            data: reqObj
          })
          .then(response => {
            console.log(response)
            console.log('Sub-brand Data Updated-->', response.data)
            this.$store.state.appStore.selectedSubbrandInfo = response.data
          })
          .catch(error => {
            console.log('Error while updating', error.response.data)
          })
      } else {
        console.log('Sub-brand not avaliable to save')
      }
    }
  }
}
</script>

<style>
</style>
